import identificationValidation from "./identificationValidation";
import residentialDetailsValidation from "./residentialDetailsValidation";
import uploadDocumentsValidation from "../commonValidationSchema/uploadDocumentsValidation";

/**
 * This returns an object composed of conditional `yup` schema,
 * based on the current tab for the company secretary officials.
 *
 * @param {string} selectedTab The current tab/step of the multi step form e.g `"generalInformation"`.
 * @param {string} idType The idType of the current official e.g `"Kenyan Citizen"`.
 * @param {string} isNonResident Conditional string value `'No' || 'Yes` of the current official.
 * @param {array} documentData The array of objects related to file uploads.
 * @return {object} This returns object containing schema.
 * @example
 *  {
 *    schema // yup schema
 *  }
 */
const getValidationSchema = ({
  selectedTab,
  idType,
  isNonResident = null,
  documentData,
}) => {
  if (!selectedTab?.id)
    return identificationValidation(idType)
      .schema.concat(
        residentialDetailsValidation({ idType, isNonResident }).schema
      )
      .concat(uploadDocumentsValidation(documentData).schema);

  switch (selectedTab.id) {
    case "generalInformation":
      return identificationValidation(idType);
    case "residentialDetails":
      return residentialDetailsValidation({ idType, isNonResident });
    case "uploadDocuments":
      return uploadDocumentsValidation(documentData);
    default:
      return { schema: null };
  }
};

export default getValidationSchema;
